import { useContext } from 'react';
import { SettingsContext } from './settings.context';

/** returns app settings, authorized settings model by default */
export const useSettings = () => {
    const { settings } = useContext(SettingsContext);

    return settings;
};
